<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../stores/rcpMng.store";
    import { login_id } from "../stores/auth.store";
    import Header from "../components/Header.svelte";

    let rcpList = [];
    let sdate = "";
    let edate = "";

    onMount(() => {
        apiGetRcpList();
    });

    async function apiGetRcpList() {
        var startDateObj = new Date(sdate);
        var endDateObj = new Date(edate);

        if (startDateObj > endDateObj) {
            alert("시작일은 종료일보다 빨라야 합니다.");
            return;
        }

        rcpList = await api.apiGetRcpList(sdate, edate);
    }
</script>

<Header />

<div class="menu-title">
    <p class="info-title" style="text-align: center;">입 고 내 역</p>
</div>

<div class="cmn-date" style="margin-top: 15px;">
    <input
        bind:value={sdate}
        type="date"
        id="sdate_m"
        placeholder="날짜를 선택해주세요."
    />
    <p>~</p>
    <input
        bind:value={edate}
        type="date"
        id="edate_m"
        placeholder="날짜를 선택해주세요."
    />
</div>

<div class="cmn-date-btn">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <p on:click={apiGetRcpList}>조회</p>
</div>

<div class="main-wrap">
    <div class="list-dtl-wrap scroll-custom">
        <table>
            <tbody>
                <tr>
                    <th>입고번호</th>
                    <th>입고일자</th>
                    <th>거래처명</th>
                </tr>

                {#each rcpList as data}
                    <tr>
                        <td>{data.wrhousng_no}</td>
                        <td>{data.wrhousng_de}</td>
                        <td>{data.bcnc_nm}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>
